import {EvaluationSubCriteriaImportanceScore} from '@frontend/shared-api';

export const getIconForImportanceScore = (importanceScore?: string | null): string => {
  switch (importanceScore) {
    case EvaluationSubCriteriaImportanceScore.BASIC_ATTRIBUTE:
      return 'ph-bold ph-cell-signal-high';
    case EvaluationSubCriteriaImportanceScore.PERFORMANCE_ATTRIBUTE:
      return 'ph-bold ph-cell-signal-medium';
    case EvaluationSubCriteriaImportanceScore.ENTHUSIASM_ATTRIBUTE:
      return 'ph-bold ph-cell-signal-low';
    case EvaluationSubCriteriaImportanceScore.INDIFFERENT_ATTRIBUTE:
      return 'ph-bold ph-cell-signal-none';
    case EvaluationSubCriteriaImportanceScore.NOT_RELEVANT:
      return 'ph ph-x-circle';
    default:
      return '';
  }
};
